import { loader } from 'graphql.macro'

export default function weightUnitsQuery ({ dataLoaders, queryKey }) {
  const [, haulerId] = queryKey
  const schema = loader('./weightUnits.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    haulerId
  })
}
